module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAXCAYAAADk3wSdAAAAAXNSR0IArs4c6QAAAS9JREFUSEvt1D0oRlEYB/Cfj0iZDAZko8TARGRTMvhYyMRiYDGKshqURSaDURmUiMEkkQ0Dm2RmM1hk0NF763Vz3/fgtTnr+T+/e855nm4ZhrCDaqVZC2XowFoJ0Y2Axq5KvMWEY9EpbOAYE8XgGHQQR6jIYZuYLQQXQ7txgpoUsoLlLLgQ2oZz1GUUL2L1q70stBkXaCzyfjPYSme+QhtyV24t1pDc/jAO87NptBZn6IwEQ+wVA7m6j7J8NHT3FH3fAJPoM/pxk4+WYw8jPwCTkif04j456TrmfwEmpQ/oCWg9HksAJsRSctIwzJN5cBWaIj70kjrQHaaz5rQdtxHoLsZj5jRkwkhdR6D7GPtHP71AVqP+5E27cBXRqAOMxjYqzOklWgrA4Ucyh+105h0fFjF98dgfMQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/up.png
// module id = XtJf
// module chunks = 1